module.exports = __webpack_public_path__ + "static/media/gh-2.0febccbf.png";